import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css';
import moment from 'moment';
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.use(VueAxios, axios);
Vue.use(MintUI);
Vue.prototype.$moment = moment;
moment.locale('zh-cn');
Vue.config.productionTip = false
// // 控制全局的静态资源图片地址
// if (window.location.origin !== 'http://localhost:8080') {
//   Vue.prototype.static_url = ''; // 本地开发
// }else{
//   Vue.prototype.static_url = 'http://47.101.168.130/qiye'; // 测试静态资源地址
// }

// Vue.prototype.remoteUrl = function(url) {
//   console.log(url);
//   return url;
// }

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
